// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Certifications.Modals.EditorWelcomeModalContentWrapper = createReactClass({

    render: function() {
      return (
        <div>
          <Certifications.Modals.EditorWelcomeModalIntro/>
        </div>
      );
    }

  });
})();
